export const apiUrl = process.env.VUE_APP_DOMAIN;
export const appName = process.env.VUE_APP_NAME;
